import { useGetMyRestProfile } from '@/api/rest/users/useGetMyRestProfile';
import { DecoratedAccount } from '@payaca/types/accountTypes';

// PrivateRouting holds a loading gate until the profile query has settled,
// so route components can rely on a non-null account — the same contract as
// the Redux read this replaces.
export const useAccount = (): DecoratedAccount => {
  const { data } = useGetMyRestProfile();
  return data?.accounts[0] as DecoratedAccount;
};
